export interface IDailySalesReport {
  entityName: string;
  locationDailySales: [
    {
      locationTotalCost?: number;
      totalItemsSold?: number;
      locationEntityName?: string;
      locationName: string;
      operatorNumber: string;
      operatorName: string;
      numberOfSales: number;
      firstSale: string;
      lastSale: string;
      dailySalesProductData: IDailySalesProductData[];
      totalCash: number;
      totalCredit: number;
      totalMobileMoney: number;
      totalElectronic: number;
      totalEFT: number;
      grandTotalSales: number;
      totalDiscount: number;
      totalTaxes: number;
    }
  ];
  startDate: string;
  endDate: string;
  numberOfSales: number;
  totalCash: number;
  totalCredit: number;
  totalMobileMoney: number;
  totalElectronic: number;
  totalEFT: number;
  grandTotalSales: number;
  totalDiscount: number;
  totalTaxes: number;
}

export interface IDailySalesProductData {
  productName: string;
  productCode: string;
  sku: string;
  quantity: number;
  value: number;
  discountValue: number;
  taxRate: number;
  taxValue: number;
  costPrice: number;
}
